import { AppsTable } from './components/AppsTable/AppsTable';

export function AppsPage() {
  return (
    <main className="bg-background page-gutter min-h-0 flex-1 overflow-x-hidden py-4 md:py-6">
      <AppsTable />
    </main>
  );
}
